import styled from 'styled-components';

export const VacancyDetailsInfoWrapper = styled.div``;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const InfoWrapper = styled.div`
  display: flex;
`;

export const InfoBlock = styled.div`
  margin-right: 48px;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;

  & > div:first-child {
    margin-right: 8px;
  }

  & > div:last-child {
    max-width: 341px;
    word-break: break-word;
  }
`;

export const NeededSkillsListWrapper = styled.ul`
  padding-left: 16px;
  margin-bottom: 0;
`;

export const NeededSkillsListElement = styled.li`
  margin-bottom: 8px;
  color: ${({ theme }) => theme.colors.primary.grey};

  & > div {
    position: relative;
    left: -5px;
    max-width: 340px;
    word-break: break-word;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;

  & > div:first-child {
    margin-right: 6px;
  }
`;
